// src/components/HoursRow.jsx
import React from 'react';
import HourSlot from './HourSlot';

function HoursRow({ hours = [], machine }) {
  // Mapujemy dane godzinowe, klucz: godzina (jako string)
  const hoursMap = {};
  hours.forEach(hourData => {
    hoursMap[hourData.hour] = hourData;
  });

  // Tworzymy pełny zakres godzin (00–23)
  const fullHours = [];
  for (let h = 0; h < 24; h++) {
    const hourStr = h.toString().padStart(2, '0');
    fullHours.push(
      hoursMap[hourStr] || { hour: hourStr, running: 0, available: 0, percent: 0 }
    );
  }


  return (
    <div className="machine-data" data-machine-name={machine.name}>
      {fullHours.map((hourData, index) => (
        <HourSlot key={index} hourData={hourData} machine={machine} />
      ))}
    </div>
  );
}

export default HoursRow;
